import { render } from "./Bamboo.vue?vue&type=template&id=aab5f69c"
import script from "./Bamboo.vue?vue&type=script&lang=js"
export * from "./Bamboo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__